import React, { useCallback, useState } from 'react';
import { ScreenWrapper } from '../../components/Wrappers/ScreenWrapper';
import { TMaterialStyles } from '../../theme';
import { Illustration } from '../../components/Illustration';
import { ERoutes } from '../../enums';
import { useNavigate } from 'react-router';
import { RulesModal } from '../../components/Modals/RulesModal/RulesModal';
import { competitionModeRules } from '../../api';
import { getCompetitionModeData } from '../../queries';

const CompetitionRulesScreen: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = useCallback(() => {
    navigate(ERoutes.gameModes);
  }, [navigate]);

  const [showRulesModal, setShowRulesModal] = useState<boolean>(true);

  const startGameHandler = useCallback(async () => {
    try {
      await getCompetitionModeData();
      navigate(ERoutes.competitionMode);
    } catch (error) {
      console.error('Error while [getCompetitionModeData]', error);
    }
  }, [navigate]);

  return (
    <ScreenWrapper onBack={handleBack} isAbsolute>
      <RulesModal
        showRulesModal={showRulesModal}
        setShowRulesModal={setShowRulesModal}
        rules={competitionModeRules}
        startGameHandler={startGameHandler}
      />
      <Illustration
        sx={materialStyles.streetView}
        illustrationName="StreetViewMock"
      />
    </ScreenWrapper>
  );
};

const materialStyles: TMaterialStyles = {
  streetView: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    objectFit: 'cover',
  },
};

export default CompetitionRulesScreen;
